import React, { useContext, useRef, useState } from 'react'
import { Badge, Col, Divider, Input, Popconfirm, Popover, Row, Tour, TourProps } from 'antd';
import styles from './header.module.scss';
import LN from 'utils/language';
import { onChangePublic } from 'redux/actions/public';
import { useRedux } from 'redux/useRedux';
import { Navigate, useNavigate } from 'react-router-dom';
import { statusSubscription, tree_digit_number } from 'utils/globalFunction';
import { LogoutIcon, MenuIcon, NotificationIcon, SettingIcon, UserIcon } from 'assets/svgComponent';
import { AuthContext } from 'contexts/auth-context';
const HeaderComponent = () => {
    const [refresh, setRefresh] = useState(false)
    const { dispatch, publicState, authState } = useRedux()
    const navigate = useNavigate()
    const ctx = useContext(AuthContext);
    const [openProfile, setOpenProfile] = useState(false);

    return (
        <Row justify="space-between" className={styles.header} align={"middle"}>

            <MenuIcon className={styles.menuWeb} onClick={() => {
                dispatch(onChangePublic('sider_open', !publicState?.sider_open))
            }} />
            <MenuIcon className={styles.menuMobile} onClick={() => {
                dispatch(onChangePublic('drawer_open', !publicState?.drawer_open));
            }} />
            <Row className={styles.menuWeb} >
                {/* <Row>
                    <NotificationIcon className={styles.icon} />
                    <p className='t5 white100 ms10'>پیام ها</p>
                </Row> */}
                {/* <Divider className={styles.divider} type='vertical' /> */}
                <Row onClick={()=>ctx.handleLogout()} className='pointer'>
                    <LogoutIcon  className={styles.icon} />
                    <p className='t5 white100 ms10'>خروج </p>
                </Row>
            </Row>
            <Row className={styles.menuMobile} >
                <Popover  arrow={false} overlayClassName='profilePopover' content={
                    <Row justify={"space-between"} align={"middle"} className={"fullWidth"}  >
                        <Col className='me50'>
                            <p className='t2 white100 '>{ctx.user?.first_name} {ctx.user?.last_name}</p>
                            <p className='t5 ' style={{ color: "yellow" }}>کاربر {statusSubscription(ctx)}</p>
                        </Col>
                        <SettingIcon className={styles.settingIcon} />
                    </Row>
                }  trigger="click"  >
                <div onClick={() => setOpenProfile(true)} className={styles.profile}>
                    <UserIcon />
                </div>
                    </Popover>

            </Row>





        </Row>

    )
}

export default HeaderComponent
